import { DisclaimerBox } from "./styles";

export const Disclaimer: React.FC = () => {
    return (
        <div>
            <DisclaimerBox>
                <p>Siglas: g = gramas | mg = miligramas </p>
                <p>
                    Valores baseados na tabela nutricional fornecida pelo próprio subway,
                    possível margem de erro existente{" "}
                </p>
            </DisclaimerBox>
        </div>
    );
};
